import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  padding-right: ", "em;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background-color: ", ";\n  border-radius: 2em;\n  box-shadow: ", ";\n  display: inline-flex;\n  flex-direction: row;\n  height: ", "em;\n  padding: 0 ", "em;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { color, property } from '@scp/ui-shared/theme/variables';
import { LinkOrButton } from '@scp/ui-shared/components/buttons/LinkOrButton';
import { Icon } from '@scp/ui-shared/theme/icons';
import { withRippleEffect } from '@scp/ui-shared/theme/ripple-effect';
import { Paragraph } from '@scp/ui-shared/components/typography';
var Bubble = styled(LinkOrButton)(_templateObject(), color.action, property.boxShadow, 40 / 14, 12 / 14);
var Text = styled(Paragraph).attrs({
  medium: true,
  noMargin: true,
  as: 'span'
})(_templateObject2(), color.palette.white);
var ButtonIcon = styled(Icon).attrs({
  color: color.palette.white
})(_templateObject3(), 12 / 14);
var BubbleWithRipple = withRippleEffect(Bubble, undefined, false);
/**
 * @example ./__docs__/BubbleButton.md
 */

export function BubbleButton(_ref) {
  var onClick = _ref.onClick,
      children = _ref.children,
      iconName = _ref.iconName,
      className = _ref.className;
  return React.createElement(BubbleWithRipple, {
    onClick: onClick,
    className: className
  }, iconName && React.createElement(ButtonIcon, {
    name: iconName,
    size: 18
  }), React.createElement(Text, null, children));
}